import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { Loader2, ShieldCheck, ShieldX, BadgeCheck } from "lucide-react";

export default function SporaVerify() {
  const { id } = useParams();
  const [state, setState] = useState("loading");
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/verify/${encodeURIComponent(id)}`).then((r) => { setData(r.data); setState("valid"); }).catch(() => setState("invalid"));
  }, [id]);

  return (
    <div className="grain flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md animate-fadeUp">
        <Link to="/" className="mb-8 flex flex-col items-center gap-2">
          <img src="/spora1-logo.webp" alt="SPORA1" className="h-12 w-auto" />
          <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-muted-foreground">
            One Ecosystem <span className="text-primary">•</span> One Technology <span className="text-primary">•</span> Many Champions
          </p>
        </Link>
        <div className="rounded-2xl border border-border bg-card p-8 text-center shadow-2xl">
          {state === "loading" && <Loader2 className="mx-auto h-8 w-8 animate-spin text-primary" />}
          {state === "invalid" && (
            <div className="flex flex-col items-center gap-3">
              <div className="rounded-full bg-rose-500/15 p-4"><ShieldX className="h-10 w-10 text-rose-400" /></div>
              <p className="font-display text-2xl font-bold">Not verified</p>
              <p className="text-sm text-muted-foreground">This SPORA ID could not be verified.</p>
            </div>
          )}
          {state === "valid" && data && (
            <div className="flex flex-col items-center gap-3" data-testid="verify-result">
              {data.photo_url
                ? <img src={data.photo_url} alt={data.name} data-testid="verify-photo" className="h-24 w-24 rounded-full border-4 border-emerald-500/30 object-cover" />
                : <div className="rounded-full bg-emerald-500/15 p-4"><ShieldCheck className="h-10 w-10 text-emerald-400" /></div>}
              <div className="flex items-center gap-2">
                <p className="font-display text-2xl font-bold">{data.name}</p>
                <BadgeCheck className="h-5 w-5 text-cyan" />
              </div>
              <span className="rounded-full bg-primary/15 px-3 py-1 text-sm font-medium text-primary">{data.type}</span>
              {data.sport && <p className="text-sm text-muted-foreground">{data.sport}</p>}
              <p className="mt-2 text-xs text-muted-foreground">Verified SPORA1 member{data.since ? ` since ${data.since}` : ""}.</p>
              <p className="mt-4 rounded-lg border border-border bg-background/40 px-4 py-2 text-xs text-muted-foreground">
                For privacy, only the member's name and role are shown. No contact or performance data is exposed.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
